<div class="">
  <nav class="navbar navbar-expand-lg navbar-light">
    <div>
      {{(referralsData$|async).summary.name|titlecase}}({{(referralsData$|async).summary.user_contact}})
    </div>
    <form class="col form-inline my-2 my-lg-0">
      <input type="text" class="form-control" pInputText size="30" placeholder="Search Farmer"
        (input)="dt.filterGlobal($event.target.value, 'contains')" />
      <span type='submit' class="ui-dropdown-filter-icon pi pi-search" style="margin-inline-start: -30px;"></span>
    </form>
    <p-calendar placeholder='Select Date' #range_Dates="ngModel" id="rangeDates" inputId="range_date"
      [(ngModel)]="rangeDates" inputId='rangeDates' yearRange="2000:2030" selectionMode="range" [monthNavigator]="true"
      [yearNavigator]="true" [readonlyInput]="true" [showButtonBar]="true"
      (onClickOutside)="filterByDate($event)"
      (onClose)="filterByDate($event)"
      (onClearClick)="filterByDate($event)" #calendar>
    </p-calendar>
    <button class="ui-btn ml-auto" (click)="dt.exportCSV({selectionOnly:true})">
      <i aria-hidden="true" class="fa fa-download"></i>Download ({{selectedItems.length}})
    </button>
  </nav>
</div>

<div class=''>
  <div class="overlay-container">
    <span>
      <p-table #dt [columns]="cols" [value]="(referralsData$|async).refferred" styleClass="table table-primary"
        [(selection)]="selectedItems" [globalFilterFields]="['name','user_contact','district']"
        [loading]="(referralsData$|async).loaders.refferred">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Name</th>
            <th>Phone</th>
            <th>District</th>
            <th>Date</th>
            <th>Paid</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [ngClass]="{'row-accessories': item.cleared}">
            <td>
              <p-tableCheckbox [value]="item" [disabled]='item.cleared'></p-tableCheckbox>
            </td>
            <td>
              <div class="font-weight-bold">{{item.name}}</div>
            </td>
            <td>{{item.user_contact}}</td>
            <td>{{item.district}}</td>
            <td>{{item.referred_at|date}}</td>
            <td>
              <div [ngClass]="{'paid': item.cleared, 'notpaid': !item.cleared}">
                {{item.cleared?'Yes':'No'}}
                <span *ngIf="item.cleared">{{item.amount_paid||0}}</span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="row" *ngIf="(referralsData$|async).refferred as data">
            <div class="col">
              Total Farmers
              <br>
              {{data.length}}
            </div>
            <div class="col">
              Total Commission
              <br>
              {{data.length*(commissionRate$|async)|currency:'UGX'}}
            </div>
            <div class="col">
              Total Received
              <br>
              {{(referralsData$|async).summary.total_paid|currency:'UGX'}}
            </div>
            <div class="col">
              Balance
              <br>
              {{((data.length-(referralsData$|async).summary.total_farmers_paid)*(commissionRate$|async))-(referralsData$|async).summary.total_paid|currency:'UGX'}}
            </div>
          </div>
        </ng-template>
      </p-table>
    </span>
  </div>
  <div class="text-center loader" *ngIf="(referralsData$|async).loaders.refferred">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>